module.exports = __webpack_public_path__ + "img/hamburger.09185485.svg";